import React, {FC} from 'react';

import {DropdownBoxCoordinator} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {SettingsPreferenceItemInheritableProps} from '../settingsPreferencesList';

/*
 * Props.
 */

interface SettingsPreferencesDropdownItemProps<T> extends SettingsPreferenceItemInheritableProps<T> {
  value: T;
  values: ReadonlyArray<T>; // enums
  valueDisplayNames: ReadonlyArray<string>; // enumTitles
  defaultValue?: T | null;
}

/*
 * Component.
 */

export const SettingsPreferencesDropdownItem = <T,>(
  props: SettingsPreferencesDropdownItemProps<T>,
): ReturnType<FC> => {
  const {defaultValue, value, values, valueDisplayNames, updatePreference} = props;
  let currentValueIndex = values.indexOf(value);
  if (currentValueIndex === -1 && defaultValue) {
    currentValueIndex = values.indexOf(defaultValue);
  }

  const renderDropdown = (popoverProps: PopoverTransferProps) => (
    <SimpleDropdown {...popoverProps}>
      {valueDisplayNames.map((name, index) => (
        <SimpleDropdownItem
          key={name}
          onSelect={() => updatePreference(values[index])}
          isChecked={index === currentValueIndex}
          shouldReserveRightIcon
        >
          {name}
        </SimpleDropdownItem>
      ))}
    </SimpleDropdown>
  );

  return (
    <DropdownBoxCoordinator
      value={valueDisplayNames[currentValueIndex]}
      renderDropdown={renderDropdown}
      noInputMarginRight
    />
  );
};
